<template>
    <div>
        <el-select v-model="selectedPart" class="select" clearable filterable remote :remote-method="searchParts" placeholder="Please select part" :loading="loading" @change="partSelected">
            <el-option v-for="item in parts" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
    </div>
</template>

<script>
import api from "../api";
export default {
  name: "service-ticket-part-selector",

  props: {
    serviceCompanyId: {
      type: Number
    },
    productId: {
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      selectedPart: undefined,
      parts: [],
    };
  },
  methods: {
    searchParts(term) {
      if (term !== "") {
        var self = this;
        self.loading = true;
        api
          .getParts(term, this.serviceCompanyId, this.productId)
          .then(function(response) {
            self.loading = false;
            self.parts = response.data;
          });
      }
    },
    partSelected(value) {
      if (value === "") {
        this.parts = [];
      }

      console.log(value)
      this.$emit("part-selected", this.parts.find(c => c.id === value));
    },
    reset() {
      this.selectedPart = undefined;
      this.parts = [];
    }
  }
};
</script>

<style scoped>
.select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/servicetickets/components/ServiceTicketPartSelector.vue